<template>
  <v-container fill-height :style="{
      backgroundColor: colors.blue,
      margin: 0,
      minWidth: '100%',
      position: 'relative'
    }">
    <!-- Language Switcher - Top Right -->
    <div style="position: absolute; top: 20px; right: 20px; z-index: 10;">
      <LanguageSwitcher />
    </div>

    <div
      :style="{
        backgroundImage: 'url(/assets/bg.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        opacity: 0.1
      }">
    </div>

    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="auto">
        <h2 class="text-center mb-4" :style="{color: colors.secondary}">{{ $t('welcome.title') }}</h2>

        <v-img
          src="/assets/baobabwhite.png"
          alt="Baobab Logo"
          min-width="100%"
          class="mx-auto mb-4"
        ></v-img>
        
        <div :style="{backgroundColor: colors.secondary, borderRadius: '20px'}">
          <h3 class="text-center mb-4">{{ $t('welcome.developedBy') }}</h3>

          <a href="https://thewebsquare.com" target="_blank">
            <v-img
              src="/assets/logo.png"
              alt="Developed By Logo"
              max-width="250"
              class="mx-auto mb-4"
              style="border-bottom: 1px solid #e5e5e5; width: 300px; padding: 10px; margin: 0 auto;"
            ></v-img>
          </a>

          <div style="width: 200px; margin: 0 auto; padding:5px;">
            <div style="display: flex; justify-content: space-between">
              <div>
                <a href="https://pyramidpos.com" target="_blank">
                  <v-img
                    src="/assets/logopyramid.png"
                    alt="Developed By Logo"
                    max-width="50"
                    class="mx-auto mb-4"
                    style="width: 300px; margin: 0 auto;"
                  ></v-img>
                </a>
              </div>
              <div>
                <a href="https://rest-o-pos.com" target="_blank">
                  <v-img
                    src="/assets/rop.png"
                    alt="Developed By Logo"
                    max-width="50"
                    class="mx-auto mb-4"
                    style="width: 300px; margin: 0 auto;"
                  ></v-img>
                </a>
              </div>
            </div>
          </div>
          
          <a href="https://nexta.mg" target="_blank">
            <v-img
              src="/assets/incube.png"
              alt="Incube Image"
              max-width="75"
              class="mx-auto mb-4"
            ></v-img>
          </a>
        </div>

        <v-btn
          class="mx-auto mt-4"
          :color="colors.primary"
          @click="goToJuryLogin"
        >
          {{ $t('common.continue') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import colors from "../styles/colors";
import LanguageSwitcher from './LanguageSwitcher.vue';

export default {
  name: 'WelcomeScreen',
  components: {
    LanguageSwitcher,
  },
  data() {
    return {
      colors,
    }
  },
  methods: {
    goToJuryLogin() {
      this.$router.push('/jury-login');
    }
  }
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}

.text-center {
  text-align: center;
}
</style>